module.exports = __webpack_public_path__ + "static/media/logo-organda.d5072133.png";